import React from "react";

const Rellax = () => {
  return (
    <section className="rellax mt-5  ">
      <div className="container ">
        <div className="row align-items-center upDown py-5 bg text-center">
          <div className="col-lg-4">
            <div className="text-right">
              <h3>مميزات بوليصة</h3>
              <p>
                نقدم الكثير من المميزات للمتاجر الالكترونية لشحن منتجاتهم الى
                عملائهم في جميع مدن ومحافظات المملكة العربية السعودية
              </p>
            </div>
          </div>
          <div className="col-lg-8 me-auto">
            <div className="row align-items-center gap-0 g-0 g-2">
              <div className="col-lg-6">
                <div className="crd   p-4 rounded rounded-3 ">
                  <div className="icon orange">
                    <i class="fa-solid fa-chart-simple"></i>
                  </div>
                  <div className="info">
                    <h3>خيارات شحن متعددة</h3>
                    <p>
                      قم باختيار ما يناسبك من قائمة شركات الشحن المتوفرة لدينا
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="crd   p-4 rounded rounded-3 ">
                  <div className="icon turquoise">
                    <i class="fa-solid fa-money-check-dollar"></i>{" "}
                  </div>
                  <div className="info">
                    <h3> احصل على افضل سعر</h3>
                    <p>قارن بين أسعار الشحن و اختر افضل سعر يناسبك</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="crd   p-4 rounded rounded-3 ">
                  <div className="icon red">
                    <i class="fa-solid fa-file-invoice"></i>{" "}
                  </div>
                  <div className="info">
                    <h3>بدون عقود</h3>
                    <p>
                      لست بحاجة الى توقيع عقود شركات الشحن المحلية و العالمية
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="crd   p-4 rounded rounded-3 ">
                  <div className="icon green">
                    <i class="fa-solid fa-hand-holding-dollar"></i>{" "}
                  </div>
                  <div className="info">
                    <h3>دفع عند الاستلام</h3>
                    <p>استلم مبالغ الدفع عند الاستلام في محفظتكم الالكترونية</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="crd   p-4 rounded rounded-3 ">
                  <div className="icon green">
                    <i class="fa-solid fa-location-dot"></i>{" "}
                  </div>
                  <div className="info">
                    <h3>توصيل إلى جميع أنحاء المملكة</h3>
                    <p>
                      نوفر لك تغطية شاملة في جميع أنحاء المملكة، نغطيها بمراكز
                      توزيعنا الخاصة ومن خلال شركائنا.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="crd   p-4 rounded rounded-3 ">
                  <div className="icon green">
                    <i class="fa-solid fa-truck-fast"></i>{" "}
                  </div>
                  <div className="info">
                    <h3>تجربة شحن ذكية</h3>
                    <p>
                      اشحن بكل سهولة بدون ما تحتاج تطبع بوليصة الطلبات من خلال
                      أكياس الشحن الذكية من بوسطة.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="crd   p-4 rounded rounded-3 ">
                  <div className="icon green">
                    <i class="fa-solid fa-cloud-sun"></i>{" "}
                  </div>
                  <div className="info">
                    <h3>تسليم بيوم وليلة</h3>
                    <p>
                      نوصّل شحنتك بعد 24 ساعة مباشرة، ونسبة نجاح التوصيل توصل
                      إلى 96%. ترى هذي أحد أكبر المعدلات في سوق الخدمات
                      اللوجستية
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="crd   p-4 rounded rounded-3 ">
                  <div className="icon green">
                    <i class="fa-solid fa-clipboard-check"></i>{" "}
                  </div>
                  <div className="info">
                    <h3>خدمة احترافية شاملة</h3>
                    <p>
                      نقدم لك جميع الخدمات اللوجستية اللي تحتاجها: تخزين، شحن
                      وتوصيل سريع، استرجاع واستبدال الشحنات، تحصيل الأموال.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Rellax;
